export type Filter = {
  // Ids
  id?: string | string[]; // record ID
  ca?: string | string[]; // campaignId / campaignCode
  co?: string | string[]; // couponId / couponCode
  cu?: string | string[]; // customerId
  d?: string | string[]; // dialogId
  l?: string | string[]; // learnerId
  t?: string | string[]; // ticketId
  sce?: string | string[]; // scenarioId
  bc?: string; // before createdAt (timestamp in seconds)
  ac?: string; // after createdAt (timestamp in seconds)
  limit?: number; // Limit of records
  offset?: number; // Offset of records
  fetchDeleted?: boolean; // Include deleted records
  isAssessed?: boolean; // dialog has valid assessment data from dialog_assessments table
  isCanDo?: boolean; // dialog has valid can do data from dialog_can_do table
  isConfirmed?: boolean; // coupons.isConfirmed
  isEnded?: boolean; // dialog.endedAt is not null
  isRead?: boolean; // notifications.isRead
  email?: string | string[]; // Email of user (single value or array)
  page?: string; // Page of the learner web app
  s?: string | string[]; // Status of record (single value or array)
  p?: number; // Priority of record

  // New filter properties
  op?: string; // Operator ID
  sortBy?: string; // Field to sort by
  sortOrder?: "asc" | "desc"; // Sort direction
  search?: string | string[]; // Text search term
  permissions?: string | string[]; // Permission types, matches status pattern
  bo?: number; // before openAt (openAt <= timestamp)
  acl?: number; // after closedAt (closedAt > timestamp)
};

export function normalizeToArray(
  input: string | string[] | undefined | null,
): string[] | undefined {
  if (!input) {
    return undefined;
  }

  if (Array.isArray(input)) {
    return input.filter(
      (item): item is string => typeof item === "string" && item.trim() !== "",
    );
  }

  if (typeof input !== "string") {
    return undefined;
  }

  return input
    .split(",")
    .map((item) => item.trim())
    .filter((item) => item !== "");
}

type ArrayValue = string | number | boolean | undefined | null;
type SingleValue = string | number | boolean | undefined | null;

type FilterValue = SingleValue | ArrayValue[];

export function objectToFilterString(obj: Record<string, FilterValue>) {
  return (
    Object.entries(obj)
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      .filter(([_, value]) => value !== undefined && value !== null)
      .map(([key, value]) => {
        if (Array.isArray(value)) {
          return value
            .filter((v): v is string | number | boolean => {
              return v !== undefined && v !== null;
            })
            .map((v) => `${key}=${v}`)
            .join("&");
        }

        return `${key}=${value}`;
      })
      .filter(Boolean)
      .join("&")
  );
}
